import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState, useEffect, useRef, useContext, useMemo } from "react";
import AppLink from "../router/app-link";
import DropdownItem from "../tailwind/dropdown-item";
import Dropdown from "../tailwind/dropdown";
import DropdownToggle from "../tailwind/dropdown-toggle";
import {
  CustomerCommand,
  CustomerCommandMetadata,
} from "../../types/customer-command";
import AuthContext from "../auth-context";
import CommandData from "../../types/command-data";

function ServicesDropdown() {
  const [toggle, setToggle] = useState(false);
  const [commandItems, setCommandItems] = useState<
    {
      command: CustomerCommand;
      description: string;
      path: string | undefined;
    }[]
  >([]);
  const menuRef = useRef<HTMLDivElement>(null);

  let context = useContext(AuthContext);
  let serviceType = context.serviceType;
  let commands = useMemo(() => {
    return context.internetcommands || [];
  }, [context.internetcommands]);

  useEffect(() => {
    const handler = (e: any) => {
      if (!menuRef.current?.contains(e.target)) {
        setToggle(false);
      }
    };
    document.addEventListener("mousedown", handler);

    return () => {
      document.removeEventListener("mousedown", handler);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const filteredCommandItems = commands
      .filter(
        (commandObj: CommandData) => commandObj.command in CustomerCommand
      )
      .map((commandObj: CommandData) => {
        const { command } = commandObj;
        const { description, path } =
          CustomerCommandMetadata[
            command as keyof typeof CustomerCommandMetadata
          ] || {};
        return { command, description, path };
      });

    setCommandItems(filteredCommandItems);
    // eslint-disable-next-line
  }, [commands, serviceType]);

  return (
    <div className="navbar-content">
      <Dropdown className="dd-backdrop dd-backdrop-none-md">
        <DropdownToggle
          id="id-nav-post-btn"
          className="btn-bold btn-outline-primary mx-2 px-2 px-lg-3 radius-round"
          aria-haspopup="true"
          aria-expanded="false"
          onClick={() => setToggle((toggle) => !toggle)}
        >
          <FontAwesomeIcon icon="plus" className="mr-lg-1" />
          <span className="d-lg-inline">خدمات</span>
        </DropdownToggle>
        <div
          ref={menuRef}
          className={
            "dropdown-menu-right dropdown-animated brc-primary-m3 radius-2 py-2 py-md-0 dd-slide-up dd-slide-none-md " +
            (toggle ? "show" : " ")
          }
        >
          <div className="dropdown-inner">
            <div className="d-md-none">خدمت درخواستی:</div>
            {commandItems.map(
              ({ command, description, path }) =>
                description != null && (
                  <DropdownItem key={command}>
                    <AppLink
                      className="btn-h-light-primary btn-a-light-primary"
                      to={path || "/"}
                      onClick={() => {
                        setTimeout(() => setToggle(false), 0);
                      }}                    >
                      <FontAwesomeIcon
                        icon="circle"
                        className="text-primary-m2 text-75 ml-2"
                      />
                      {description}
                    </AppLink>
                  </DropdownItem>
                )
            )}
            <DropdownItem>
              <AppLink
                className="btn-h-light-primary btn-a-light-primary"
                to="request/adsl" 
                onClick={() => {
                  setTimeout(() => setToggle(false), 0);
                }} 
              >
                <FontAwesomeIcon
                  icon="circle"
                  className="text-primary-m2 text-75 ml-2"
                />
                درخواست خط ADSL
              </AppLink>
            </DropdownItem>
            <DropdownItem>
              <AppLink
                className="btn-h-light-primary btn-a-light-primary"
                to="request/td"
                onClick={() => {
                  setTimeout(() => setToggle(false), 0);
                }} 
              >
                <FontAwesomeIcon
                  icon="circle"
                  className="text-primary-m2 text-75 ml-2"
                />
                درخواست خط TD-LTE
              </AppLink>
            </DropdownItem>
            <DropdownItem>
              <AppLink
                className="btn-h-light-primary btn-a-light-primary"
                to="request/fd"
                onClick={() => {
                  setTimeout(() => setToggle(false), 0);
                }} 
              >
                <FontAwesomeIcon
                  icon="circle"
                  className="text-primary-m2 text-75 ml-2"
                />
                درخواست خط FD-LTE
              </AppLink>
            </DropdownItem>
            <DropdownItem>
              <AppLink
                className="btn-h-light-primary btn-a-light-primary"
                to="request/ngn"
                onClick={() => {
                  setTimeout(() => setToggle(false), 0);
                }} 
              >
                <FontAwesomeIcon
                  icon="circle"
                  className="text-primary-m2 text-75 ml-2"
                />
                درخواست خط NGN
              </AppLink>
            </DropdownItem>
          </div>
        </div>
      </Dropdown>
    </div>
  );
}

export default ServicesDropdown;
